/**
 * @desc 财务画像-概述-财务风险
 * @author caoyx
 */
import React, { PureComponent } from 'react';
import { Tabs } from 'antd';
import { addDataIndex } from '../../../../utils/util';
import GroupBox from '../../../common/groupBox/GroupBox';
import { commonRequest } from '../../common/commons';
import ScorePane from '../../common/scorePane/ScorePane';
import IndexPane from './common/IndexPane';
import Danger from './risk/Danger';
import { queryOverviewRisk } from '../../../../services/financialPicture/overview';
const TabPane = Tabs.TabPane;

export default class FinancialRisk extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            baseData: {},
            indexData: [],
            indexValueData: [],
            pathData: [],
            loading: true
        };
    }

    componentDidMount() {
        this.getRiskData();
    }

    getRiskData = () => {
        queryOverviewRisk(commonRequest()).then(data => {
            data = data || {};
            let { riskScoreTypeList, riskAbnormalIndexValueList, riskAbnormalIndexList, ...financeData } = data;

            this.setState({
                baseData: {
                    ...financeData,
                    radarData: riskScoreTypeList || []
                },
                indexData: addDataIndex(riskAbnormalIndexList),
                indexValueData: riskAbnormalIndexValueList || [],
                loading: false
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    };

    render() {
        const {
            loading,
            baseData,
            indexData,
            indexValueData
        } = this.state;

        const { explain, riskTotalScore, industry, radarData } = baseData;

        return (
            <GroupBox title="财务风险" explain={explain} industry={industry}>
                <Tabs defaultActiveKey="score" animated={false} className="line-tabs margin" >
                    <TabPane tab="财务风险评分" key="score">
                        <ScorePane loading={loading} score={riskTotalScore} radarData={radarData}/>
                    </TabPane>
                    <TabPane tab="财务隐患提示" key="danger">
                        <Danger />
                    </TabPane>
                    <TabPane tab="财务风险点提示" key="index">
                        <IndexPane loading={loading} indexData={indexData} indexValueData={indexValueData} type="risk"/>
                    </TabPane>
                </Tabs>
            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/overview/subComponents/FinancialRisk.jsx